import React from 'react';
import '../../styles/table-main/main.css';

const Main = () => {
    return (
        <div id='tableMain'>
            <div className="table-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Affiliation</h2>
                                {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Sno</th>
                                                <th>Title</th>
                                                <th>Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>01</td>
                                                <td>
                                                    Standards for Salary and Service Conditions of Teachers and
                                                    Non-Teaching Staff in Self-Financed Programs Under Higher
                                                    Education
                                                </td>
                                                <td>
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/G.O.%2013.03.2020.pdf"
                                                        className="btn btn-primary btn-download"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>02</td>
                                                <td>
                                                    Delegation of Powers for Granting NOC to Open New
                                                    Colleges/Institutions and Start Additional Courses in
                                                    Existing Colleges
                                                </td>
                                                <td>
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/G.O%20dated%2009-08-2012.pdf"
                                                        className="btn btn-primary btn-download"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>03</td>
                                                <td>
                                                    Determination of Standards for Opening New
                                                    Colleges/Institutions in the Field of Higher Education{" "}
                                                </td>
                                                <td>
                                                    <a
                                                        href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/b.ed%20G.O.PDF"
                                                        className="btn btn-primary btn-download"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        Download
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <a
                                    href="https://henoc.upsdc.gov.in/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#000", fontSize: 18 }}
                                >
                                    Online NOC &amp; Affiliation System
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;